import script from "./DescriptionSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./DescriptionSection.vue?vue&type=script&lang=ts&setup=true"

import "./DescriptionSection.vue?vue&type=style&index=0&id=a330223c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a330223c"]])

export default __exports__